module.exports = __webpack_public_path__ + "static/media/08.21fed87f.wav";